export const INVENTORY_ACTIONS = [
    { label: 'Import Inventory', value: 'Import Inventory' },
    { label: 'Download Sample', value: 'Download Sample' },
    { label: 'Import Sales Grade', value: 'Import Sales Grade' },
    { label: 'Download Sales Grade Sample', value: 'Download Sales Grade Sample' },
    { label: 'Import COGs', value: 'Import COGs' },
    { label: 'Download COGs Sample', value: 'Download COGs Sample' },
]